export enum HostSeatErrors {
  HOST_SEAT_NOT_FOUND = "HOST_SEAT_NOT_FOUND",
  MISSING_DATA = "MISSING_DATA",
  SEAT_NOT_FOUND = "SEAT_NOT_FOUND",
}
